import type { Currency, CurrencyOptions } from "./types";

export const CURRENCIES: CurrencyOptions<Currency> = [
	{ label: "EUR/HUF", value: "eur", longName: "euró", url: "/deviza/euro-arfolyam/" },
	{ label: "USD/HUF", value: "usd", longName: "dollár", url: "/deviza/usd-arfolyam/" },
];
